import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import Api from '../../../services/api';
import DataService from './data.service';
import DataProvider from '../../../app/data-framework/data-provider';
import WebResourceSecure from './web-resource-secure.service';
import AssuranceAlertService from './assurance.alert.service';
import LoginService from "../../../services/login.service";
import moment from "moment-timezone";


function getQueryStringFromParams(params) {
        var queryString = '';
        _.forEach(params, function (param, key) {
            if (!_.isEmpty(param) || _.isFinite(param)) {
                if (!_.isEmpty(queryString)) {
                    queryString += '&';
                }

                queryString = queryString + key + '=' + param;
            }
        });
        if (queryString) {
            queryString = '?' + queryString;
        }
        return queryString;
    }

export default {
        fetchDataset: function (datasetName, params) {
          let endpoint = datasetName.toLowerCase();
          let urlPromise;
          if (endpoint === 'spaces' || endpoint === 'networks' || endpoint === 'buildings' || endpoint === 'sensors') {
            urlPromise = DataProvider.getInstance().fetchAssuranceMdmServiceBaseURL();
          } else if (endpoint === 'documents') {
            urlPromise = DataProvider.getInstance().fetchAssuranceAdrServiceBaseURL(); // SU single org
          } else if (endpoint === 'all-documents' || endpoint === 'last-documents') {
            urlPromise = DataProvider.getInstance().fetchAssuranceAdrServiceSuBaseURL(); // SU cross org
          } else if (endpoint.endsWith('xml') || endpoint.startsWith('summaryview')) {
            urlPromise = DataProvider.getInstance().fetchAssuranceDashboardServiceV2BaseURL();
          } else {
            urlPromise = DataProvider.getInstance().fetchAssuranceQueryServiceBaseURL();
          }
          return urlPromise.then(function (baseUrl) {
                if (endpoint.endsWith('xml') || endpoint.startsWith('summaryview')) {
                    params.dataset = datasetName;
                    let requestParams  = {
                        datasetRequest: {
                            dataset: datasetName,
                            start: moment(params.start).format('YYYY-MM-DD'),
                            end: moment(params.end).format('YYYY-MM-DD'),
                            sort: params.dataSort,
                            pageSize: params.size,
                            page: params.page + 1, // page in CPMA query is 1 based but our UI pages are zero based because they are zero based in CPMM
                        }
                    };
                    if (!_.isEmpty(params.dataFilter)) {
                      requestParams.datasetRequest.filter = params.dataFilter;
                    }
                    return Api.request({
                        url: baseUrl + '/data',
                        method: 'POST',
                        responseType: 'json',
                        data: requestParams
                      })
                      .then(response => response.data) 
                      .then(responseData => {
                        let response = responseData.datasetRequest;
                        return {
                            content: response.results,
                            limitReached: (response.pageId !== undefined && response.pageCount !== undefined) ? response.pageId >= response.pageCount : false, 
                            pageNumber: response.pageId !== undefined ? response.pageId : 0,
                            pageSize: response.pageSize !== undefined ? response.pageSize : response.results.length,
                            totalCount: response.recordCount !== undefined ? response.recordCount : response.results.length,
                            totalPages: response.pageCount !== undefined ? response.pageCount : 1
                        };
                      })
                      .catch(error => {
                        console.error('Failed Request', error);
                        throw error;
                      });
                } else  {
                    if (endpoint === 'infrastructures') {
                        endpoint = 'systems';
                    }
                    if (endpoint === 'all-documents') {
                        endpoint = 'documents';
                    }
                    delete params.dataFilter; // todo - had to delete it so it didn't much up the query params
                    let url = baseUrl + '/' + endpoint + (endpoint === 'alerts' ? '' : getQueryStringFromParams(params));
                    return WebResourceSecure.getJSON(url).then(function(results) {
                        if (endpoint === 'alerts') {
                            results = {
                                "totalCount": results.length,
                                "totalPages": 1,
                                "pageNumber": 0,
                                "pageSize": results.length,
                                "limitReached": false,
                                "content": results
                            };
                            let alerts = results.content;
                            return AssuranceAlertService.updateAlertDefinitions(alerts, results);
                        }
                        return results;
                    });
                }
                    
            });
        },

        fetchMeetingParticipants: function (params) {
            return DataProvider.getInstance().fetchAssuranceQueryServiceV2BaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/meetings' + '/' + params.meetingId + '/' + params.startTime + '/participants?sort=quality,asc';
                    return WebResourceSecure.getJSON(url);
                });
        },

        fetchMetrics: function (payload) {
            return DataProvider.getInstance().fetchAssuranceQueryServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/metrics';
                    return WebResourceSecure.getJSON(url, payload, 'POST');
                });
        },

        fetchMetricModels: function () {
            var models = DataService.fetchMetricModelsCache();

            var promise;
            if (_.isEmpty(models)) {
                promise = DataProvider.getInstance().fetchAssuranceQueryServiceBaseURL()
                    .then(function (baseUrl) {
                        var url = baseUrl + '/metrics/models?filter_system_types=true';
                        return WebResourceSecure.getJSON(url).then(function (models) {
                            DataService.cacheMetricModels(models);
                            return models;
                        });
                    });
            } else {
                promise = Promise.resolve(models);
            }
            return promise;
        },

        fetchEndpointTags: function () {
            var tags = DataService.fetchEndpointTagsCache();

            var promise;
            if (_.isEmpty(tags)) {
                promise = DataProvider.getInstance().fetchAssuranceAppsServiceBaseURL()
                    .then(function (baseUrl) {
                        var url = baseUrl + '/endpoints/tags';
                        return WebResourceSecure.getJSON(url).then(function (response) {
                            DataService.cacheEndpointTags(response);
                            return response;
                        });
                    });
            } else {
                promise = Promise.resolve(tags);
            }
            return promise;
        },

        setMonitorEnabled: function (id, enabled) {
            return DataProvider.getInstance().fetchAssuranceAlertConfigServiceBaseURL()
            .then(function (baseUrl) {
                let method = 'PATCH';
                let url = baseUrl + '/alerts/' + id;

                let payload = {
                    enabled : enabled,
                };

                return WebResourceSecure.getJSON(url, payload, method, 'json');
            });
        },

    };
